import { TimePickerLocale } from '../TimePicker';

const locale: TimePickerLocale = {
  placeholder: 'Seleccionar hora',
};

export default locale;
